import { makeVar, useReactiveVar } from "@apollo/client";

// Whether a career track's table reads widest-first (company-wide, shared,
// the track's own, then responsibilities) instead of the usual narrowest
// first. Shared by every track's table, like the edit mode, so switching
// tracks keeps it.
const isRowOrderReversedVar = makeVar(false);

const useRolesRowOrder = () => {
  const isRowOrderReversed = useReactiveVar(isRowOrderReversedVar);
  return {
    isRowOrderReversed,
    toggleRowOrder: () => isRowOrderReversedVar(!isRowOrderReversedVar()),
  };
};

export default useRolesRowOrder;
